import { render, staticRenderFns } from "./ProductScreenshotsList.vue?vue&type=template&id=8051b358"
import script from "./ProductScreenshotsList.vue?vue&type=script&lang=js"
export * from "./ProductScreenshotsList.vue?vue&type=script&lang=js"
import style0 from "./ProductScreenshotsList.vue?vue&type=style&index=0&id=8051b358&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports